import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminCommissionsService } from '../../core/services/admin-commissions.service';
import { CommissionSettings } from '../../core/models/admin.models';

@Component({
  selector: 'app-commissions',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './commissions.component.html'
})
export class CommissionsComponent implements OnInit {
  commission: CommissionSettings | null = null;
  isLoading = false;
  isSaving = false;
  errorMessage = '';

  constructor(private commissionsService: AdminCommissionsService) {}

  ngOnInit() {
    this.loadCommission();
  }

  loadCommission() {
    this.isLoading = true;
    this.errorMessage = '';

    this.commissionsService.getCommission().subscribe({
      next: (res) => {
        this.commission = res || { rate: 0, type: 'percent' };
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load commissions.';
        this.isLoading = false;
        // Fallback for UI building
        this.commission = { rate: 15, type: 'percent' };
      }
    });
  }

  saveCommission() {
    if (!this.commission) return;
    
    this.isSaving = true;
    this.commissionsService.updateCommission(this.commission).subscribe({
      next: () => {
        this.isSaving = false;
        alert('Commission updated successfully!');
      },
      error: (err) => {
        this.isSaving = false;
        alert(err?.error?.message ?? 'Failed to update commission.');
      }
    });
  }
}
